import { theme } from 'lib';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  background-color: ${theme.DARK_PURPLE};
  align-items: center;
  display: flex;
  flex-direction: column;

  .header-text {
    font-family: CeraStencil;
    font-size: 40px;
    color: #fff;
    font-weight: 700;
    line-height: 33px;
    text-indent: 25px;
    width: 247px;
  }

  @media (max-width: 1024px) {
    width: 100vw;
  }
`;

const ContentArea = styled.div`
  margin-top: 80px;
  width: 1140px;

  @media (max-width: 1024px) {
    margin: 48px 13px 0;
    width: auto;
  }
`;

const SponsorWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  margin-top: 52px;
  margin-bottom: 92px;

  @media (max-width: 1024px) {
  }
`;

const ImageBackground = styled.div`
  background: url(${(props) => props.src});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 250px;
  height: 150px;

  @media (max-width: 1024px) {
    width: 130px;
    height: 75px;
  }
`;

const Partners = (props) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <ContentArea>
        <div className="header-text">{t('website.ourPartners')}</div>

        <SponsorWrapper>
          <ImageBackground src={require('assets/images/wiregrass-ranch.png')} />
          <ImageBackground src={require('assets/images/sports-coast.png')} />
          <ImageBackground src={require('assets/images/radd-sports.png')} />
          <ImageBackground src={require('assets/images/advent-health.png')} />
        </SponsorWrapper>
      </ContentArea>
    </Wrapper>
  );
};

export default Partners;
